import React, { useState } from "react";
import { shortJobId } from "../../../core/data/jobs";
import { runningShare } from "../../../core/data/auditsPage";
import { jobStatus } from "../../../core/data/reportCore";
import { STATUS_LABELS, formatDate, snapshotListTitle } from "../../../core/data/marketOverviewText";
import { STATUS_PILL } from "../../../core/theme/reportTheme";
import { AUDITS } from "../../../core/theme/auditsTheme";

// One snapshot in the Audits list: its name and date, then
// "Market Snapshot · 120 searches · 2 hours", the status pill, #AB12 and its tags.
// A running snapshot also has Stop (asks first), and with showBar a thin
// progress bar (Industry Audits page). onHover (optional) gets the job when
// the pointer or keyboard focus is on the row, and null when it leaves.
export default function SnapshotRow({ job, onOpen, onStop, onHover, showBar = false }) {
  const [stopping, setStopping] = useState(false);
  const status = jobStatus(job.status, job.stop_reason);
  const id = shortJobId(job.id);

  const stop = async () => {
    if (!window.confirm("Stop this snapshot? Searches not run yet will be skipped. This can't be undone.")) return;
    setStopping(true);
    await onStop(job.id);
    setStopping(false);
  };

  return (
    <div
      className={AUDITS.row}
      onMouseEnter={onHover && (() => onHover(job))} onMouseLeave={onHover && (() => onHover(null))}
      onFocus={onHover && (() => onHover(job))} onBlur={onHover && (() => onHover(null))}
    >
      <button type="button" onClick={() => onOpen(job)} className={AUDITS.rowOpen}>
        <div className={AUDITS.rowTop}>
          <p className={AUDITS.rowName}>{job.name || (job.keywords || []).join(", ")}</p>
          <span className={AUDITS.rowDate}>{formatDate(job.started_at)}</span>
        </div>
        <div className={AUDITS.rowMeta}>
          <span className={AUDITS.rowTitle}>{snapshotListTitle(job)}</span>
          <span className={STATUS_PILL[status]}>{STATUS_LABELS[status]}</span>
          <span className={AUDITS.rowId} title={`Snapshot id ${id}`}>#{id}</span>
          {(job.tags || []).map(t => <span key={t} className={AUDITS.tag}>{t}</span>)}
        </div>
        {showBar && job.status === "running" && (
          <div className={AUDITS.rowBar} role="progressbar" aria-label="Searches done" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(runningShare(job) * 100)}>
            <div className={AUDITS.rowBarFill} style={{ width: `${runningShare(job) * 100}%` }} />
          </div>
        )}
      </button>
      {job.status === "running" && onStop && (
        <button type="button" onClick={stop} disabled={stopping} className={AUDITS.stop}>{stopping ? "Stopping…" : "Stop"}</button>
      )}
    </div>
  );
}
